import * as Yup from "yup";

type IClassroomSchema = {
  name: string;
  roomNumber: string;
};

const classroomSchema: Yup.ObjectSchema<IClassroomSchema> = Yup.object().shape({
  name: Yup.string().required("Room Name is required."),
  roomNumber: Yup.string().required("Room number is required."),
});

export { classroomSchema };
export type { IClassroomSchema };
